import React from 'react'
// import Link from 'gatsby-link'
import '../assets/fonts/fonts.css';
import {css} from 'emotion';
import NavBar from '../components/NavBar';
// import Footer from '../components/Footer';
import Helmet from 'react-helmet';
import Header from '../components/appComponents/Header';



/* global tw */
const SecondPage = () => (
  <div className={css`${tw`max-w-screen overflow-x-hidden relative w-screen`}`}>
    <Helmet
      // title='Taxi near me, Taxi Service Near Me ,Rental Car with a Difference'
      //  title = 'Zyppys - #1 Outstation Car Rental Services in India. Book Zyppys car rentals for hassle-free journeys for family trips and outings with friends!'
      title ='Zyppys offers premium chauffeur-driven luxury car rentals across India, ensuring an unparalleled travel experience with professional service and a curated fleet.Book your ride today!'
      // title = "Self-Drive Car Rental In India : Outstation Cabs | Rent A Car | Car Hire Online | Outstation Taxi Booking Service | Airport Transfers | Book Hourly Rental Car - ZYPPYS"
      meta={[
        { name: 'description', content: 'Hiring self-drive car is in on your fingertip Zyppys is one of the best car rental services for outstation cabs, cab to airport and more. Zyppys is pocket and environment friendly.' },
        // { name: 'description', content: 'Self Drive Car Rental In India - Outstation Cabs - Airport Transfer Services - Hourly Rental Car : Book best Self-drive car rentals online, hire Self drive cars without driver, Outstation cabs, Outstation taxi, Airport transfer services and Hourly rental cars at affordable prices at ZYPPYS in India.' },
        { name: 'keywords', content: 'Zyypys, Car Rental, car rental near me, car rental app, car rental bangalore, car rental hyderabad, Roadtrip, Outstation Cabs, Road Travel, Chauffeur Driven Cars, Rental Cars, Cheap Rental Cars, Vacation Rentals, Outstation Rentals, Bike Rentals, Aha Taxis, Revv, Zoomcar, Avis, Hertz, Gozo Cabs, Savaari, Taxi Bazaar, Quick Ride, Car Pooling, Car sharing, Travel, Road travel, Airport Taxi, Self Drive Cars, Car Rentals, self drive car hire bangalore,self drive car rental bangalore ,self drive hire bangalore, self drive rental bangalore,self drive car hire hyderabad,self drive car rental hyderabad ,self drive hire hyderabad, self drive rental hyderabad,self drive hire cars ,self drive car rental ,self drive hire , self drive rental , car rental hyderabad, car hire hyderabad,car rental bangalore, car hire bangalore, Bangalore to Coorg car Rental, Bangalore to Mysore car Rental, Bangalore to Ooty car Rental, car rental, car hire, car rental near, outstation cabs, outstation car rental, outstation cabs one way, outstation cabs booking, car booking outstation, Bangalore to Chikmagalur cabs, outstation cabs hyderabad, outstation car rentals hyderabad, outstation cabs one way hyderabad, hyderabad to karimnagar cabs, bangalore to mysore cab, hyderabad to vijayawada cabs, hyderabad to warangal cabs,bangalore to coorg cab,bangalore to ooty cab, bangalore to nandi hills cab, cars, Bangalore to Pondicherry cabs, bangalore to tirupati cab, outstation cabs bangalore, outstation car rentals bangalore, cabs from hyderabad to srisailam, hyderabad to bangalore cab, Bangalore to Kodaikanal cabs, Bangalore to Chennai cabs, Bangalore to Wayanad cabs ' },
        { name: "Viewport", content: "width=device-width" },
        { property: "og:image", content: 'https://zyppysimages.s3.ap-south-1.amazonaws.com/zyplogo.png' },
        { property: "og:image:width", content: "200" },
        { property: "og:image:height", content: "200" },
        { property: "og:type", content: "website" },
        { property: "og:title", content: "Self Drive Cars & Rental Car, Car Rental, Cab on Rent" },
        { property: "og:description", content: "Best car rental service for individual, family, corporate, self-drive cars and customize services for urban & semi-urban cities in India. Zyppys is a platform where people can compare and rent a car." },
        // { property: "og:url", content: "https://zyppys.com/" },
        { property: "og:site_name", content: "Zyppys" },
        { property: "og:locale", content: "en_US" }
      ]}
    />
    <div style={{
    width: "100vw",
    maxWidth: "100vw",
    minHeight: "10vh",
    overflowX: "hidden",
    overflowY: "auto",
    position: "relative",
    background: "#09080F",
    backgroundImage:
      "radial-gradient(ellipse 70% 50% at 50% 0%, rgba(124,58,237,0.35), transparent 65%), radial-gradient(ellipse 40% 30% at 90% 30%, rgba(168,85,247,0.18), transparent 70%), linear-gradient(180deg, #1A1527 0%, #09080F 100%)",
    fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
  }}>
      <Header/>
    </div>
        {/* <NavBar/> */}
        <div className={css`
            ${tw`terms px-2 md:px-4 lg:px-16 pb-16`};
            background: #0D0B14;
            background-image: radial-gradient(ellipse 40% 30% at 50% 0%, rgba(124,58,237,0.12), transparent 70%);
            font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
            padding-top: 3rem;
            margin-top: 0;
            h4 {
                font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                font-weight: 700;
                color: #F0ECF9;
                letter-spacing: -0.02em;
            }
            p, .content {
                font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                font-weight: 400;
                color: rgba(255,255,255,0.6);
                font-size: 0.9375rem;
                line-height: 1.7;
                letter-spacing: -0.005em;
            }
        ` + ' row'}>
        <div style={{
            display: "inline-block",
            textTransform: "uppercase",
            letterSpacing: "0.12em",
            fontSize: "0.75rem",
            fontWeight: 700,
            color: "#7C3AED",
            marginBottom: "1rem",
        }}>Legal</div>
        <h2 style={{
            fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
            fontWeight: 800,
            fontSize: "2.5rem",
            color: "#F0ECF9",
            letterSpacing: "-0.035em",
            lineHeight: 1.1,
            marginBottom: "2rem",
        }}>Terms &amp; Conditions</h2>
        <div className="content">
        <p>Last updated: 5-11-2025<br/><br/>
Welcome to Zyppys.com, operated by Twilight IT Professionals Pvt. Ltd. ("Zyppys," "we," "our," or "us"). By accessing or using the Zyppys website, mobile app, or related services (collectively, the "Platform"), you agree to be bound by the following Terms and Conditions ("Terms"). Please read them carefully before using our services.</p>
        </div>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">1. Eligibility</h4>
        <p className="content">
        By using Zyppys, you confirm that you:<br/>
- Are at least 18 years old and legally competent to enter into contracts;<br/>
- Are using the Platform for lawful purposes; and<br/>
- Have provided accurate and complete information during registration or booking.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">2. Services Offered</h4>
        <p className="content">
        Zyppys provides a digital platform that enables users to:<br/>
- Book chauffeur-driven luxury and premium vehicles for personal, corporate, or event transportation;<br/>
- Manage guest transportation through bulk or individual bookings;<br/>
- Receive real-time updates, invoices, and ride information.<br/><br/>
Zyppys facilitates vehicle booking between customers and verified chauffeurs or operators. We act as an intermediary and are not a transportation company or vehicle owner (except where explicitly stated).
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">3. User Accounts</h4>
        <p className="content">
- You may be required to create an account to access certain features.<br/>
- You are responsible for maintaining confidentiality of your login credentials.<br/>
- You agree to notify Zyppys immediately in case of unauthorized access.<br/>
- Zyppys reserves the right to suspend or terminate any account for misuse or violation of these Terms.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">4. Bookings &amp; Payments</h4>
        <p className="content">
- All bookings are subject to vehicle and chauffeur availability.<br/>
- Payment options include online payment, UPI, or credit/debit card through secure payment gateways.<br/>
- Full or partial payment may be required to confirm the booking.<br/>
- Any additional charges (e.g., tolls, parking, waiting time, outstation charges) are billed separately.<br/>
- Zyppys reserves the right to cancel or modify bookings due to unforeseen circumstances.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">5. Cancellations &amp; Refunds</h4>
        <p className="content">
- User-initiated cancellations must be made within the specified window mentioned in the booking confirmation.<br/>
- Cancellation fees may apply depending on the time of cancellation.<br/>
- Refunds, if applicable, are processed within 7–10 business days.<br/>
- Zyppys reserves the right to cancel any booking due to force majeure or operational reasons, with a full refund.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">6. Responsibilities of Users</h4>
        <p className="content">
Users agree to:<br/>
- Provide accurate pickup and drop-off details;<br/>
- Treat chauffeurs and vehicles respectfully;<br/>
- Avoid illegal activities or transporting prohibited goods;<br/>
- Not use the vehicle for sub-leasing, racing, or unlawful purposes.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">7. Chauffeur Conduct &amp; Service Quality</h4>
        <p className="content">
Zyppys ensures all chauffeurs are verified, trained, and professional. However, Zyppys does not guarantee specific chauffeur behavior and shall not be held liable for actions beyond reasonable control.<br/><br/>
If you experience any service-related issue, please report it immediately to <a href="mailto:support@zyppys.com">support@zyppys.com</a> or call <a href="tel:+918688901902">+91 8688 901 902</a>.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">8. Liability Disclaimer</h4>
        <p className="content">
- Zyppys is not liable for delays, accidents, loss, or damage arising from acts of third-party operators or unforeseen events.<br/>
- Users are responsible for their personal belongings.<br/>
- Zyppys will not be liable for indirect, incidental, or consequential damages.<br/>
- Maximum liability for any claim shall not exceed the booking amount paid.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">9. Corporate &amp; Event Bookings</h4>
        <p className="content">
- Bulk booking terms, payment schedules, and cancellation policies are governed by separate agreements or contracts.<br/>
- Zyppys reserves the right to withhold service if payments are delayed or contractual terms are breached.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">10. Platform Usage</h4>
        <p className="content">
You agree not to:<br/>
- Copy, modify, or distribute Zyppys content without authorization;<br/>
- Use bots, crawlers, or scraping tools;<br/>
- Introduce malware or disrupt platform operations.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">11. Data Privacy</h4>
        <p className="content">
Your personal information is collected and processed as per our Privacy Policy. By using Zyppys, you consent to such collection and usage for the purpose of providing and improving our services.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">12. Intellectual Property</h4>
        <p className="content">
All content, logos, trademarks, software, and design elements on Zyppys are owned by or licensed to Twilight IT Professionals Pvt. Ltd. Unauthorized use is strictly prohibited.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">13. Modification of Terms</h4>
        <p className="content">
Zyppys reserves the right to modify or update these Terms at any time. Changes become effective once posted on the website. Continued use of the Platform constitutes acceptance of the revised Terms.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">14. Termination</h4>
        <p className="content">
Zyppys may suspend or terminate your access for breach of Terms, fraudulent activity, or misuse of the service. Outstanding dues will remain payable even after termination.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">15. Governing Law &amp; Jurisdiction</h4>
        <p className="content">
These Terms are governed by the laws of India, and any disputes shall be subject to the exclusive jurisdiction of the courts in Hyderabad, Telangana.
        </p>
        </div>
        <br/>

        <div>
        <h4 className="mt-8 mb-4 font-bold text-grey-darkest">16. Contact Information</h4>
        <p className="content">
For questions or complaints, please contact:<br/>
Email: <a href="mailto:support@zyppys.com">support@zyppys.com</a><br/>
Phone: <a href="tel:+918688901902">+91 8688 901 902</a><br/>
Website: <a href="https://www.zyppys.com">www.zyppys.com</a>
        </p>
        </div>

        </div>
  </div>
)


export default SecondPage
